module.exports = __webpack_public_path__ + "img/1490639689.b444c5c6.jpg";